var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasePage',{attrs:{"title":_vm.feature.title,"subtitle":_vm.feature.description,"img":_vm.feature.preview.filename},on:{"finish":_vm.finish}},[_c(_vm.Content,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }